import { useEffect } from "react";
import { useToast } from "@app/ui";
import { setDemoMode, setDemoWriteNotifier } from "../api/client.js";
import { useAuth } from "./AuthContext.js";
import { useT } from "../i18n.js";

/**
 * Wires read-only demo behaviour into the API client. While a demo login is
 * active every form stays fully interactive, but a mutating request is
 * intercepted before it leaves the browser: no data reaches the server and a
 * localized "changes are disabled" toast explains why. The API rejects demo
 * writes too (DEMO_READ_ONLY) as the real, defense-in-depth guarantee. Renders
 * nothing.
 */
export function DemoWriteGuard() {
  const { user } = useAuth();
  const toast = useToast();
  const t = useT();

  useEffect(() => {
    const isDemo = !!user?.demo;
    setDemoMode(isDemo);
    setDemoWriteNotifier(
      isDemo
        ? () => {
            const message = t("demo.writeBlocked");
            toast.warning(message);
            return message;
          }
        : null,
    );
    return () => {
      setDemoMode(false);
      setDemoWriteNotifier(null);
    };
  }, [user, toast, t]);

  return null;
}
